<template>
  <div
    v-if="!singleSequence"
    class="progress-container white-width"
    :style="{
      width:
        interval.start_frame === -1
          ? currentSliderPercent
          : interval.start_frame + '% !important',
    }"
  />

  <a-dropdown
    class="painter-context"
    placement="top"
    :trigger="isMarking ? [] : 'contextmenu'"
  >
    <div
      v-if="!singleSequence"
      class="progress-container marked-label"
      :class="[
        { 'highlighted-label': isOverlapped },
        { 'bordered-label': showBorder },
      ]"
      :data-test-id="`${interval.end_frame} to ${interval.start_frame}`"
      :style="[{ width: intervalWidth + '% !important' }]"
    >
      <slot name="intervalName" />
    </div>
    <div v-else class="progress-container marked-label" :style="getMarkerStyle">
      <slot name="intervalName" />
    </div>
    <template #overlay>
      <a-menu>
        <a-menu-item v-if="contextMenuItems['text']" style="max-width: 300px">
          {{ contextMenuItems['text'] }}
        </a-menu-item>
        <a-menu-item
          v-if="contextMenuItems['remove']"
          @click="$emit('removeInterval')"
        >
          {{ contextMenuItems['remove'] }}
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>
<script>
export default {
  name: 'CyclePainter',
  props: [
    'isMarking',
    'contextMenuItems',
    'interval',
    'currentSliderPercent',
    'showBorder',
    'singleSequence',
  ],

  emits: ['removeInterval'],

  computed: {
    isOverlapped() {
      const { start_frame, end_frame } = this.interval;
      const { currentSliderPercent } = this;
      return (
        start_frame <= currentSliderPercent && currentSliderPercent <= end_frame
      );
    },

    intervalWidth() {
      const { interval } = this;
      if (interval?.start_frame === -1) return 0;
      let endWidth =
        interval?.end_frame === -1
          ? this.currentSliderPercent
          : interval?.end_frame;
      const width = endWidth - interval?.start_frame;
      return width;
    },

    borderOnOverlapped() {
      return this.showBorder && this.isOverlapped
        ? '1px solid darkgrey'
        : 'none';
    },

    getMarkerStyle() {
      if (this.interval.start_frame !== -1) {
        return {
          left: `${this.interval.start_frame}% !important`,
          backgroundColor: 'blue',
          width: '2px',
        };
      } else if (this.interval.end_frame !== -1) {
        return {
          left: `${this.interval.end_frame}% !important`,
          backgroundColor: 'maroon',
          width: '2px',
        };
      }
      return {};
    },
  },
};
</script>
<style scoped>
.progress-container {
  height: 20px;
}

.marked-label {
  font-size: small;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  background-color: #add8e6;
  box-sizing: border-box;
}

.highlighted-label {
  background-color: #85cae0;
  border: v-bind(borderOnOverlapped);
}

.bordered-label:hover {
  border: 1.2px solid darkgrey;
}
</style>
